import _ from 'underscore';
import Backbone from 'backbone';

export var ClassMoneyModel = Backbone.Model.extend({
  url: 'class-money',

  defaults: function () {
    return {
      resultCode: null, // -1: 입금 기준 금액 미만/출금 금액 부족, 0 : 실패,  1 : 성공
      resultText: '', // not-allowed | fail | success | can-receive | already-done | membership-required,
      expectedClassMoney: 0
    };
  },

  initialize: function () {
    _.bindAll(this, 'claim', 'parse', 'checkCanReceive');
  },

  parse: function (res) {
    return res.result;
  },

  checkCanReceive: function () {
    return this.fetch()
      .then(_.bind(this.parse, this))
      .then(
        _.bind(function (user) {
          if (!user.hasMembership) {
            // 클래스 미사용
            this.set('resultText', 'membership-required');
          } else if (user.hasMembership && user.hasClassMoney && user.classMoneyValue > 0) {
            // 클래스, classbank 효력 있음, 남은 클래스 머니 있음
            this.set({
              resultText: 'can-receive',
              expectedClassMoney: user.classMoneyValue
            });
          } else if (user.hasMembership && user.hasClassMoney && user.classMoneyValue < 1) {
            // 클래스, classbank 효력 있음. 클래스 머니 남은 금액이 없음
            this.set('resultText', 'already-done');
          } else if (user.hasMembership && !user.hasClassMoney) {
            // 클래스 있지만, classbank 효력 없음. 오픈 전 클래스 보유자(클래스 구매시 바로 지급 받았음)
            this.set('resultText', 'already-done');
          } else {
            alert(
              '죄송합니다. 클래스머니를 받을 수 없습니다. 문제가 계속되면 고객센터로 문의해주십시오.'
            );
          }

          return this.toJSON();
        }, this)
      );
  },

  claim: function () {
    if (this.get('resultText') === 'can-receive') {
      this.save();
    }
  }
});
